import React from 'react'

import { TextField, AlertWithActions, AlertWithActionsType } from '@masfront/common-b2c'
import { Field } from 'formik'

import { Box, Grid, Collapse } from '@material-ui/core'

import useICCField from './useICCFIeld'

export default function ICCField({ id, isDonorIcc }: { id: string; isDonorIcc?: boolean }) {
  const { validateICC, iccBalance, iccAvailable, isPostpaid } = useICCField(id)
  return (
    <Grid container component={Box} spacing={5}>
      <Grid item xs={6}>
        <Field
          component={TextField}
          name={isDonorIcc ? 'donorICC' : 'icc'}
          label={isDonorIcc ? 'ICC de la tarjeta donante' : 'ICC en Tienda'}
          variant="outlined"
          validate={isDonorIcc ? () => '' : validateICC}
          inputProps={{ maxLength: 19 }}
        />
      </Grid>
      {!isDonorIcc && !isPostpaid && (
        <Grid item xs={6} data-hook="balance">
          <Collapse in={iccAvailable}>
            <AlertWithActions type={AlertWithActionsType.success}>
              Saldo en tarjeta: <b>{iccBalance}€</b>
            </AlertWithActions>
          </Collapse>
        </Grid>
      )}
    </Grid>
  )
}
